<template>
  <main-input-dialog
    :is-visible.sync="computedIsVisible"
    :loading="loading"
    :title-translation="$i18n.t('dialog.relationAssignment.title')"
    dialog-width="30%"
    agree-text="dialog.agreeAssign"
    @agree="assignRelations"
    :inputs="inputs"
  >
    <template v-for="input in inputs" #[`${input.name}.input`]="data">
      <v-col cols="6" :key="input.name">
        <data-input v-model="payload[input.name]" v-bind="data" />
      </v-col>
    </template>
  </main-input-dialog>
</template>

<script>
import { get, call } from 'vuex-pathify';
import DataInput from '@/components/DataInput';

export default {
  name: 'RelationAssignmentDialog',
  components: {
    DataInput,
    MainInputDialog: () => import('@/components/MainInputDialog'),
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    selectedFeatures: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    loading: false,
    isObjsLoading: false,
    datasourceObjects: [],
    payload: {
      data_source_name: null,
      feature_id: null,
    },
  }),
  watch: {
    'payload.data_source_name': async function(nV) {
      if (!nV) return;
      this.isObjsLoading = true;
      try {
        const data = await this.getDataSourceFeatures({
          dataSource: nV,
          idsDescsOnly: true,
        });
        this.datasourceObjects =
          nV === this.currentDataSourceName ? data.filter(item => !this.selectedFeatures.includes(item.id)) : data;
      } finally {
        this.isObjsLoading = false;
      }
    },
    isVisible(nV) {
      if (nV) {
        this.payload = {};
        this.datasourceObjects = [];
      }
    },
  },
  computed: {
    dataSources: get('layers/metadata'),
    currentDataSourceName: get('layers/currentLayer@data_source_name'),
    dataSourcesArray() {
      return this.$_objectToArray(this.dataSources).filter(
        dataSource => dataSource.scope !== 'module' && dataSource.scope !== 'dxf' && dataSource.scope !== null
      );
    },
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    inputs() {
      return [
        {
          name: 'data_source_name',
          translationPath: 'dialog.relationAssignment.datasource',
          subtitle: 'dialog.relationAssignment.datasourceSubtitle',
          dataType: {
            name: 'select',
          },
          items: this.dataSourcesArray,
          itemValue: 'name',
          itemText: 'verbose_name',
          cols: '12',
          rules: [v => !!v || v == '0' || 'rules.required'],
        },
        {
          name: 'feature_id',
          translationPath: 'dialog.relationAssignment.object',
          subtitle: 'dialog.relationAssignment.objectSubtitle',
          dataType: {
            name: 'select',
          },
          items: this.datasourceObjects,
          loading: this.isObjsLoading,
          itemValue: 'id',
          itemText: 'desc',
          disabled: !this.payload.data_source_name || this.isObjsLoading,
          cols: '12',
          rules: [v => !!v || v == '0' || 'rules.required'],
        },
      ];
    },
  },
  methods: {
    getDataSourceFeatures: call('layers/getDataSourceFeatures'),
    addRelation: call('relations/addRelation'),
    async assignRelations() {
      this.loading = true;
      try {
        await this.addRelation({
          ...this.payload,
          features: this.selectedFeatures.map(ft => {
            return {
              data_source_name: this.currentDataSourceName,
              feature_id: ft,
            };
          }),
        });
      } finally {
        this.loading = false;
        this.computedIsVisible = false;
      }
    },
  },
};
</script>
